/*
  --------------------------------------------------
  Appends query params to outbound links and persists them in localStorage.
  --------------------------------------------------
*/
const STORAGE_KEY = 'queryParams';
const MATCH_SUBSTRING = 'trc_';

function getMatchingQueryParams() {
  const matchingParams = {};
  const urlParams = new URLSearchParams(window.location.search);

  for (const [key, value] of urlParams.entries()) {
    if (key.toLowerCase().includes(MATCH_SUBSTRING)) {
      matchingParams[key] = value;
    }
  }
  return matchingParams;
}

function loadStoredParams() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : {};
  } catch (error) {
    return {};
  }
}

function saveParams(params) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(params));
  } catch (error) {
  }
}

// Merge stored and new params (new values overwrite old)
function mergeParams(stored, current) {
  return { ...stored, ...current };
}

function appendParamsToOutboundLinks(params) {
  if (!params || Object.keys(params).length === 0) return;

  document.querySelectorAll('a[href]').forEach(link => {
    const linkUrl = new URL(link.href, document.baseURI);

    // Only modify outbound links (different origin)
    if (linkUrl.origin === window.location.origin) return;

    // Add parameters that are not already present
    for (const [key, value] of Object.entries(params)) {
      if (!linkUrl.searchParams.has(key)) {
        linkUrl.searchParams.append(key, value);
      }
    }

    link.href = linkUrl.toString();
  });
}

function getKameleoonParam() {
  const visitorCode = Kameleoon.API.Visitor.code;
  const kameleoonParam = new URLSearchParams();
  kameleoonParam.append('kameleoon_visitor_code', visitorCode);
  return Object.fromEntries(kameleoonParam.entries());
}

const currentParams = getMatchingQueryParams();
const storedParams = loadStoredParams();
const mergedParams = mergeParams(storedParams, currentParams);

// Update storage if new params were found
if (JSON.stringify(mergedParams) !== JSON.stringify(storedParams)) {
  saveParams(mergedParams);
}

appendParamsToOutboundLinks(mergedParams);

// Separately append Kameleoon param when available
if (typeof Kameleoon !== 'undefined' && Kameleoon.API.Visitor) {
  appendParamsToOutboundLinks(getKameleoonParam());
} else {
  window.addEventListener('Kameleoon::Started', function (event) {
    appendParamsToOutboundLinks(getKameleoonParam());
  });
}

if (window.theme.template.suffix) {
  const suffixParam = {
    'referrer_template': window.theme.template.suffix
  };
  appendParamsToOutboundLinks(suffixParam);
}

/* 
  --------------------------------------------------
  DEPRECATED - REMOVED SOON
  In buyers-guide articles there should always be an h2 tag, introducing the quality features.
  This h2 tag contains the substring "qualitätsmerkmale", and by the Rte parsing an ID is genereated for every h2 tag.
  So we look for an element in the DOM with the id that contains the string "qualitatsmerkmale".
  --------------------------------------------------
*/
const qualityFeaturesHeading = document.querySelector('[id*="qualitatsmerkmale"]');
const qualityFeaturesShortcutButton = document.querySelector('[data-anchor="quality-features"]');
if (qualityFeaturesShortcutButton && qualityFeaturesHeading) {
  if (qualityFeaturesHeading && qualityFeaturesShortcutButton) {
    qualityFeaturesShortcutButton.href = '#' + qualityFeaturesHeading.id;
  } else {
    qualityFeaturesShortcutButton.style.display = 'none';
  }
}


/*
  --------------------------------------------------
  Scrolling indicator and drag scroll for product review table
  --------------------------------------------------
*/

(function () {
  var table = document.querySelector('.ProductReviewsTable');
  if (!table) return;
  var wrapper = table.closest('.ProductReviewsTableWrapper');
  if (!wrapper) return;

  // Helper to update scrollable classes on wrapper
  function updateScrollable() {
    var atLeft = table.scrollLeft === 0;
    var atRight = table.scrollLeft + table.clientWidth >= table.scrollWidth - 1;
    var canScroll = table.scrollWidth > table.clientWidth;

    wrapper.classList.remove('scrollable--left', 'scrollable--right');
    if (canScroll) {
      if (!atLeft && !atRight) {
        wrapper.classList.add('scrollable--left', 'scrollable--right');
      } else if (atLeft) {
        wrapper.classList.add('scrollable--right');
      } else if (atRight) {
        wrapper.classList.add('scrollable--left');
      }
    }
  }

  // Allow native horizontal wheel scrolling (including horizontal scroll wheels),
  // but let vertical wheel events scroll the page, not the table
  table.addEventListener('wheel', function(e) {
    // No preventDefault: let browser handle all wheel events
  }, { passive: false });

  // Drag-to-scroll
  var isDragging = false;
  var startX, scrollStart;

  table.addEventListener('mousedown', function(e) {
    if (e.button !== 0) return;
    isDragging = true;
    startX = e.pageX;
    scrollStart = table.scrollLeft;
    table.classList.add('dragging');
    document.body.style.userSelect = 'none';
  });

  document.addEventListener('mousemove', function(e) {
    if (!isDragging) return;
    var dx = e.pageX - startX;
    table.scrollLeft = scrollStart - dx;
    updateScrollable();
  });

  document.addEventListener('mouseup', function() {
    if (isDragging) {
      isDragging = false;
      table.classList.remove('dragging');
      document.body.style.userSelect = '';
    }
  });

  // Update scrollable state on scroll/resize/init
  table.addEventListener('scroll', updateScrollable);
  window.addEventListener('resize', updateScrollable);
  updateScrollable();
})();
